// extracted by mini-css-extract-plugin
export default {"placeholderHidden":"_bdf54150","placeholder":"_c7182e1a","imageXSmall":"_f351f459","imageSmall":"_634fe5e1","imageMedium":"_dd7eacc3","imageLarge":"_3ef13603","isNarrow":"_769b5c74"};